import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LoadingState from '../../components/common/LoadingState';
import { listContent } from '../../services/contentService';
import { CONTENT_KEYS, getContentConfig } from '../../utils/contentConfig';

export default function DashboardHomePage() {
  const [counts, setCounts] = useState({
    articles: 0,
    animations: 0,
    models: 0,
  });
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let isSubscribed = true;

    async function loadCounts() {
      setLoading(true);
      setErrorMessage('');

      try {
        const [articles, animations, models] = await Promise.all(
          CONTENT_KEYS.map((key) => listContent(key))
        );

        if (!isSubscribed) {
          return;
        }

        setCounts({
          articles: articles.length,
          animations: animations.length,
          models: models.length,
        });
      } catch (error) {
        if (!isSubscribed) {
          return;
        }
        setErrorMessage(error.message ?? 'Failed to load dashboard overview.');
      } finally {
        if (isSubscribed) {
          setLoading(false);
        }
      }
    }

    loadCounts();

    return () => {
      isSubscribed = false;
    };
  }, []);

  if (loading) {
    return <LoadingState label="Loading dashboard..." />;
  }

  if (errorMessage) {
    return <p className="form-error">{errorMessage}</p>;
  }

  return (
    <div className="page-stack">
      <section className="section-heading">
        <div>
          <p className="eyebrow">Content Management</p>
          <h1>Dashboard Overview</h1>
          <p>
            Use the dashboard sections to create, edit, and publish content with
            Firebase-backed media uploads.
          </p>
        </div>
      </section>

      <div className="dashboard-cards">
        {CONTENT_KEYS.map((key) => {
          const config = getContentConfig(key);
          return (
            <article key={key} className="dashboard-card">
              <h3>{config.title}</h3>
              <p className="dashboard-count">{counts[key]}</p>
              <Link to={config.dashboardRoute}>Manage {config.title}</Link>
            </article>
          );
        })}
      </div>
    </div>
  );
}
